import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/StakeholderTips.module.scss';

const TipStakeholderEmotionalTrigger = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.triggerContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipStakeholderEmotionalTrigger')}
      </p>
    </Tip>
  );
};

export default TipStakeholderEmotionalTrigger;
